import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		sectionHeading: {
			fontWeight: "bold",
			fontSize: 18,
			color: theme.palette.custom.textPrimary,
			marginBottom: 4,
		},
		subHeading: {
			fontWeight: "bold",
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
			marginBottom: 12,
			marginTop: 8,
		},
		carouselOption: {
			alignItems: "flex-start",
			"& .MuiFormControlLabel-label": {
				marginLeft: 8,
			},
			// Radio has 9px internal padding; with flex-start that drops its icon
			// center below the bold label. Trim the top padding so the icon center
			// lines up with the first (bold label) line.
			"& .MuiRadio-root": {
				paddingTop: 0,
			},
		},
		carouselOptionTitle: {
			fontWeight: "bold",
			color: theme.palette.custom.textPrimary,
		},
		carouselOptionDescription: {
			color: theme.palette.custom.textPrimary,
		},
		contentDescription: {
			fontSize: 14,
			marginBottom: 6,
		},
		infoIcon: {
			display: "inline-flex",
			alignItems: "center",
			marginLeft: 8,
			color: theme.palette.text.secondary,
			cursor: "default",
		},
		indented: {
			paddingLeft: 50,
			marginBottom: 4,
		},
		pageSubtitle: {
			color: theme.palette.custom.textSecondary,
			marginBottom: 32,
		},
	} satisfies Record<string, CSSObject>)
}
